import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import { Modal, Button } from 'react-bootstrap';


const AdminSearchUser = () => {
  const UPDATE_USER = "update-sthan-user";
  // const [selectedRole, setSelectedRole] = useState("");

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpData, setOtpData] = useState(null);


  const [name, setName] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [selectedPranthId, setSelectedPranthId] = useState("");
  const [selectedVibhagId, setSelectedVibhagId] = useState("");
  const [selectedJillaId, setSelectedJillaId] = useState("");
  const [jillaList, setJillaList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");
  const [sthanList, setSthanList] = useState([]);
  const [selectedSthanId, setSelectedSthanId] = useState("");
  const [arthiksakhasList, setArthiksakhasList] = useState([]);
  const [selectedArthiksakhasId, setSelectedArthiksakhasId] = useState("");
  const [errors, setErrors] = useState({});
  const [khandList, setKhandList] = useState([]);
  const [Sthans, setSthans] = useState([]);
  const [pranthList, setPranthList] = useState([]);
  const [vibhagList, setVibhagList] = useState([]);
  const userRef = useRef();
  const [validName, setValidName] = useState(false);

  const [mobile, setMobile] = useState("");
  const [validMobile, setValidMobile] = useState(false);
  const [responsibilityFocus, setResponsibilityFocus] = useState(false);

  const isValidName =
    /^[\p{L}\p{M}\s.'-]{2,100}$/u.test(name.trim());

  const isValidMobile = /^[0-9]{10}$/.test(mobile);


  const [SearchResult, setSearchResult] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const SearchResultPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [userType, setUserType] = useState("Sthan");

  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [personId, setPersonId] = useState("");


  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  const errRef = useRef();

  const handleOtpClick = async (mobile) => {
    try {
      const response = await axiosPrivate.get("/get-email-otp", {
        params: {
          mobile: mobile,
        },
      });

      setOtpData(response.data);
      setShowOtpModal(true);
    } catch (err) {
      alert(
        err.response?.data?.message || "Failed to generate OTP."
      );
    }
  };


  const handleDeleteClick = async (user) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to remove this ${userType} User?\n\n` +
      `Name   : ${user.name}\n` +
      `Mobile : ${user.mobile}`
    );

    if (!confirmDelete) return;

    try {
      const response = await axiosPrivate.delete(
        `/remove-sthan-user?person_id=${user.person_id}`
      );
      searchByMobile();
      alert(response.data.message);

      // Refresh the list if needed
      // fetchSearchResults();

    } catch (error) {
      alert(
        error.response?.data?.message ||
        "Failed to remove Sthan User."
      );
    }
  };

  useEffect(() => {
    setValidName(name.trim().length >= 3);

    const phoneRegex = /^[0-9]{10}$/;
    setValidMobile(phoneRegex.test(mobile));
  }, [name, mobile]);

  // const handleEditClick = (user) => {
  //   setSelectedUser(user);
  //   setShowEditModal(true);
  // };

  const handleEditClick = (user) => {
    setSelectedUser(user);

    // Existing form states
    // setSelectedRole(user.role || "");
    setPersonId(user.person_id || "");
    setName(user.name || "");
    setMobile(user.mobile || "");
    setResponsibility(user.responsibility || "");

    // // Hierarchy selections
    // setSelectedPranthId(user.pranth_id || "");
    // setSelectedVibhagId(user.vibhag_id || "");
    // setSelectedJillaId(user.jilla_id || "");
    // setSelectedKhandId(user.khand_id || "");
    // setSelectedMandalamId(user.mandal_id || "");
    // setSelectedSthanId(user.sthan_id || "");
    // setSelectedArthiksakhasId(user.arthik_sakha_id || "");

    setShowEditModal(true);
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setSelectedUser(null);
  };

  const handleAddSthan = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);

    navigate(`/admin/add/SthanToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };

  const handleAddArthikSakha = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);
    navigate(`/admin/add/ArthiksakhaToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };

  const handleAddVibhag = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);
    navigate(`/admin/add/vibhagToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };

  const handleAddJilla = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);
    navigate(`/admin/add/jillaToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };

  const handleAddKhand = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);
    navigate(`/admin/add/khandToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };

  const indexOfLastSearchResult = currentPage * SearchResultPerPage;
  const indexOfFirstSearchResult = indexOfLastSearchResult - SearchResultPerPage;
  const currentSearchResult = SearchResult.slice(indexOfFirstSearchResult, indexOfLastSearchResult);

  const searchByMobile = async (searchTerm) => {
    try {
      setLoading(true);   // start loading
      setError(null);     // clear old error before making a new request

      const response = await axiosPrivate.get(
        `/get-users-by-mobile?role=${encodeURIComponent(userType)}&mobile=${searchTerm}`
      );

      setSearchResult(response.data);
    } catch (err) {
      console.error("Search error", err);
      setError("Search failed. Please try again.");
      setSearchResult([]); // clear old results if error
    } finally {
      setLoading(false);  // stop loading
    }
  };


  const handleMobileChange = (e) => {
    setMobile(e.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(SearchResult.length / SearchResultPerPage);

  const handleSearchClick = () => {
    setError(null);
    setHasSearched(true);
    searchByMobile(mobile.trim());
  };

  const handleChangePswdClick = (Id, Name) => {
    navigate(`/admin/change/SthanUserPswd/${Id}/${Name}`);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        person_id: personId,
        name,
        mobile,
        responsibility,
      });

      const response = await axiosPrivate.post(
        UPDATE_USER,
        data,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      showMessage("success", response.data.message);

      // Refresh the table if needed
      await searchByMobile(mobile.trim());

      handleCloseModal();


    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      if (errRef.current) {
        errRef.current.focus();
      }
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };


  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}

          {sucssMsg && (
            <div className="alert alert-success">
              {sucssMsg}
            </div>
          )}

          {errMsg && (
            <div className="alert alert-danger">
              {errMsg}
            </div>
          )}

          <h3>Search User</h3>

          <Row className="mb-3 newrowstyle">
            <Col md={2}></Col>
            <Col md={6}>
              <Form.Label className="newformstyles">Select Ultsavam</Form.Label>
              <div className="input-box arthik_input-box d-flex">
                <Form.Select
                  className="newselectstyle me-2"
                  value={userType}
                  onChange={(e) => {
                    setUserType(e.target.value);
                    setSearchResult([]);  // Clear table
                    setMobile('');               // Optional: clear search input too
                    setHasSearched(false)
                  }}
                >
                  <option value="Sthan">Sthan user</option>
                  <option value="Arthiksakha">Arthiksakha user</option>
                  <option value="Vibhag">Vibhag user</option>
                  <option value="Jilla">Jilla user</option>
                  <option value="Khand">Khand user</option>
                </Form.Select>

                <input
                  className="newinputstyles flex-grow-1"
                  type="text"
                  id="name"
                  placeholder="Search by name or mobile"
                  autoComplete="off"
                  onChange={handleMobileChange}
                  value={mobile}
                />
                {/* <button className="btn btn-primary ms-2" onClick={handleSearchClick}>
                  Search
                </button> */}
              </div>
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <button className="btn orange_btn newbtnstyles newstyleset" onClick={handleSearchClick}>
                Search
              </button>
            </Col>
            <Col md={1}></Col>
          </Row>

          <div className="table-container">
            <table id="customers">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Responsibility</th>
                  <th>Verified or not</th>
                  <th>Last login</th>
                  <th>Options</th>
                </tr>
              </thead>

              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="6" className="text-danger text-center">
                      {error}
                    </td>
                  </tr>
                ) : loading ? (
                  <tr>
                    <td colSpan="6" className="text-center">Loading...</td>
                  </tr>
                ) : hasSearched && SearchResult.length === 0 ? (
                  <tr>
                    <td colSpan="6">No Data available.</td>
                  </tr>
                ) : (
                  currentSearchResult.map((SearchResults) => (
                    <tr key={SearchResults.person_id}>
                      <td>{SearchResults.name}</td>
                      <td>{SearchResults.mobile}</td>
                      <td>{SearchResults.responsibility}</td>
                      <td>
                        {SearchResults.is_verified ? (
                          <span className="badge bg-success">Verified</span>
                        ) : (
                          <span className="badge bg-danger">Not Verified</span>
                        )}
                      </td>
                      <td>
                        {SearchResults.last_login
                          ? new Date(SearchResults.last_login).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          })
                          : "Never logged in"}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          {userType === "Sthan" ? (
                            <button
                              type="button"
                              className="btn btn-success btn-ico newicobtn newviewbtn"
                              onClick={() =>
                                handleAddSthan(
                                  SearchResults.person_id,
                                  SearchResults.name,
                                  SearchResults.mobile
                                )
                              }
                            >
                              + Sthan
                            </button>
                          ) : userType === "Arthiksakha" ? (
                            <button
                              type="button"
                              className="btn btn-success btn-ico newicobtn newviewbtn"
                              onClick={() =>
                                handleAddArthikSakha(
                                  SearchResults.person_id,
                                  SearchResults.name,
                                  SearchResults.mobile
                                )
                              }
                            >
                              + Arthiksakha
                            </button>
                          ) : userType === "Vibhag" ? (
                            <button
                              type="button"
                              className="btn btn-success btn-ico newicobtn newviewbtn"
                              onClick={() =>
                                handleAddVibhag(
                                  SearchResults.person_id,
                                  SearchResults.name,
                                  SearchResults.mobile
                                )
                              }
                            >
                              + Vibhag
                            </button>
                          ) : userType === "Jilla" ? (
                            <button
                              type="button"
                              className="btn btn-success btn-ico newicobtn newviewbtn"
                              onClick={() =>
                                handleAddJilla(
                                  SearchResults.person_id,
                                  SearchResults.name,
                                  SearchResults.mobile
                                )
                              }
                            >
                              + Jilla
                            </button>
                          ) : userType === "Khand" ? (
                            <button
                              type="button"
                              className="btn btn-success btn-ico newicobtn newviewbtn"
                              onClick={() =>
                                handleAddKhand(
                                  SearchResults.person_id,
                                  SearchResults.name,
                                  SearchResults.mobile
                                )
                              }
                            >
                              + Khand
                            </button>
                          ) : null}


                          {SearchResults.is_verified ? (
                            <button
                              type="button"
                              className="tableButton btn btn-info newicobtn newviewbtn"
                              onClick={() =>
                                handleChangePswdClick(
                                  SearchResults.user_id,
                                  SearchResults.name
                                )
                              }
                            >
                              PSWD
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="tableButton btn btn-dark newicobtn newviewbtn"
                              onClick={() => handleOtpClick(SearchResults.mobile)}
                            >
                              OTP
                            </button>
                          )}

                          <button
                            type="button"
                            className="btn btn-warning btn-ico newicobtn newviewbtn"
                            onClick={() => handleEditClick(SearchResults)}
                          >
                            <i className="bx bxs-edit icon"></i>
                          </button>


                          <button
                            type="button"
                            className="btn btn-danger btn-ico newicobtn newviewbtn"
                            onClick={() => handleDeleteClick(SearchResults)}
                          >
                            <i className="bx bxs-trash icon"></i>
                          </button>
                        </div>
                      </td>

                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div>


        <Modal
          show={showEditModal}
          onHide={handleCloseModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title class=" newraphead"><h4 class=" newraphead">Edit User</h4></Modal.Title>

          </Modal.Header>

          <Modal.Body>
            <form>

              <Row>
                {/* <Col md={6}>
                  <Form.Label className="newformstyle">Role</Form.Label>
                  <Form.Select
                    className="newselectstyle form-control guruselect"
                    value={selectedRole}
                    onChange={(e) => {
                      setSelectedRole(e.target.value);

                      setErrors((prev) => ({
                        ...prev,
                        role: "",
                      }));

                      // Optional
                      setSelectedPranthId("");
                      // setSelectedSthan("");
                    }}
                  >
                    <option value="">-- Select Role --</option>
                    <option value="Vibhag">Vibhag</option>
                    <option value="Jilla">Jilla</option>
                    <option value="Khand">Khand</option>
                    <option value="Sthan">Sthan</option>
                    <option value="Arthiksakha">Arthiksakha</option>
                  </Form.Select>

                  {errors.role && (
                    <small className="text-danger d-block mt-1">
                      {errors.role}
                    </small>
                  )}
                </Col> */}

                {/* <Col md={6}>
                  <Form.Label className="newformstyle">Pranth</Form.Label>
                  <Form.Select
                    className="newselectstyle form-control guruselect"
                    value={selectedPranthId}
                    onChange={(e) => {
                      const pranthId = e.target.value;
                      setSelectedPranthId(pranthId);

                      if (!pranthId) {
                        // Clear vibhag, jilla, and table if no Pranth selected
                        setArthiksakhasList([]);
                        setSelectedArthiksakhasId("");

                        setKhandList([]);
                        setSelectedKhandId("");

                        setSthans([]);
                      }
                      setErrors((prev) => ({
                        ...prev,
                        pranth: ""
                      }));
                      setSelectedVibhagId("");
                    }}
                  >
                    <option value="">-- Select Pranth --</option>
                    {pranthList.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </Form.Select>

                  {errors.pranth && (
                    <small className="text-danger d-block mt-1">
                      {errors.pranth}
                    </small>
                  )}
                </Col> */}

                {/* {selectedRole !== "Arthiksakha" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Vibhag</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedVibhagId}
                      onChange={(e) => {
                        const vibhagId = e.target.value;
                        setSelectedVibhagId(vibhagId);

                        if (!vibhagId) {
                          // Clear Jilla list and selection if no Vibhag selected
                          setJillaList([]);
                          setSelectedJillaId("");
                          setSthans([]); // Optional: clear table too
                          setKhandList([]);
                          setSelectedKhandId("");
                        }


                        setErrors((prev) => ({
                          ...prev,
                          vibhag: ""
                        }));
                        setSelectedJillaId("");
                      }}
                      disabled={!selectedPranthId || !vibhagList.length}
                    >
                      <option value="">-- Select Vibhag --</option>
                      {Array.isArray(vibhagList) &&
                        vibhagList.map((v) => (
                          <option key={v.vibhag_id} value={v.vibhag_id}>
                            {v.vibhag_name}
                          </option>
                        ))}
                    </Form.Select>

                    {errors.vibhag && (
                      <small className="text-danger d-block mt-1">
                        {errors.vibhag}
                      </small>
                    )}
                  </Col>
                )} */}

                {/* {["Jilla", "Khand", "Sthan"].includes(selectedRole) && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Jilla</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedJillaId}
                      onChange={(e) => {
                        const jillaId = e.target.value;
                        setSelectedJillaId(jillaId); // ✅ Just update state


                        if (!jillaId) {
                          setKhandList([]);
                          setSelectedKhandId("");
                          setSthans([]);
                        }


                        setErrors((prev) => ({
                          ...prev,
                          jilla: ""
                        }));
                        setSelectedKhandId("");
                      }}
                      disabled={!jillaList.length}
                    >
                      <option value="">-- Select Jilla --</option>
                      {jillaList.map((j) => (
                        <option key={j.jilla_id} value={j.jilla_id}>
                          {j.jilla_name}
                        </option>
                      ))}
                    </Form.Select>

                    {errors.jilla && (
                      <small className="text-danger d-block mt-1">
                        {errors.jilla}
                      </small>
                    )}
                  </Col>
                )} */}

                {/* {selectedRole === "Arthiksakha" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Arthiksakha</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedArthiksakhasId}
                      onChange={(e) => {
                        const ArthiksaId = e.target.value;
                        setSelectedArthiksakhasId(ArthiksaId);

                        setErrors((prev) => ({
                          ...prev,
                          arthiksakha: "",
                        }));
                      }}
                      disabled={!arthiksakhasList.length}
                    >
                      <option value="">-- Select Arthiksakhas --</option>
                      {Array.isArray(arthiksakhasList) &&
                        arthiksakhasList.map((v) => (
                          <option key={v.arthik_sakha_id} value={v.arthik_sakha_id}>
                            {v.arthik_sakha}
                          </option>
                        ))}
                    </Form.Select>
                    {errors.arthiksakha && (
                      <small className="text-danger d-block mt-1">
                        {errors.arthiksakha}
                      </small>
                    )}
                  </Col>
                )} */}


                {/* {["Khand", "Sthan"].includes(selectedRole) && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Khand</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedKhandId}
                      onChange={(e) => {
                        setSelectedKhandId(e.target.value);

                        setErrors((prev) => ({
                          ...prev,
                          khand: "",
                        }));

                        setSelectedMandalamId("");
                      }}
                      disabled={!khandList.length}
                    >
                      <option value="">-- Select Khand --</option>
                      {khandList.map((k) => (
                        <option key={k.khand_id} value={k.khand_id}>
                          {k.khand_name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.khand && (
                      <small className="text-danger d-block mt-1">
                        {errors.khand}
                      </small>
                    )}
                  </Col>
                )} */}

                {/* {selectedRole === "Sthan" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Mandalam</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedMandalamId}
                      onChange={(e) => {
                        const mandalamId = e.target.value;
                        setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID

                        setErrors((prev) => ({
                          ...prev,
                          mandalam: "",
                        }));

                        setSelectedSthanId("");
                      }}
                      disabled={!mandalamList.length}
                    >

                      <option value="">-- Select Mandalam --</option>
                      {mandalamList.map((m) => (
                        <option key={m.mandal_id} value={m.mandal_id}>
                          {m.mandal_name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.mandalam && (
                      <small className="text-danger d-block mt-1">
                        {errors.mandalam}
                      </small>
                    )}
                  </Col>
                )} */}


                {/* {selectedRole === "Sthan" && (
                  <Col md={6}>
                    <Form.Label className="newformstyle">Sthan</Form.Label>
                    <Form.Select
                      className="newselectstyle form-control guruselect"
                      value={selectedSthanId}
                      onChange={(e) => {
                        const sthanId = e.target.value;
                        setSelectedSthanId(sthanId); // Correctly set Mandalam ID


                        setErrors((prev) => ({
                          ...prev,
                          sthan: "",
                        }));
                      }}
                      disabled={!sthanList.length}
                    >

                      <option value="">-- Select Sthan --</option>
                      {sthanList.map((m) => (
                        <option key={m.sthan_id} value={m.sthan_id}>
                          {m.sthan_name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.sthan && (
                      <small className="text-danger d-block mt-1">
                        {errors.sthan}
                      </small>
                    )}
                  </Col>
                )} */}

                <Col md={6}>
                  <Form.Label className="newformstyle">Name</Form.Label>
                  <div className="input-box arthik_input-box">
                    <input
                      type="text"
                      id="name"
                      className="newinpstyle"
                      placeholder="Enter Name"
                      autoComplete="off"
                      ref={userRef}
                      onChange={(e) => {
                        setName(
                          e.target.value.replace(/[^\p{L}\p{M}\s.'-]/gu, "")
                        );

                        setErrors((prev) => ({
                          ...prev,
                          name: "",
                        }));
                      }}
                      value={name}
                      required
                      aria-invalid={validName ? "false" : "true"}
                      aria-describedby="namenote"
                    />


                  </div>
                  {errors.name && (
                    <small className="text-danger d-block mt-1">
                      {errors.name}
                    </small>
                  )}
                </Col>
                <Col md={6}>
                  <Form.Label className="newformstyle">Mobile number</Form.Label>
                  <div className="input-box arthik_input-box">
                    <input
                      type="text"
                      id="mobile"
                      className="newinpstyle"
                      placeholder="Enter Mobile number"
                      autoComplete="off"
                      ref={userRef}
                      onChange={(e) => {
                        setMobile(e.target.value.replace(/\D/g, ""));

                        setErrors((prev) => ({
                          ...prev,
                          mobile: "",
                        }));
                      }}
                      value={mobile}
                      required
                      aria-invalid={validMobile ? "false" : "true"}
                      aria-describedby="mobilenote"
                      maxLength={10}
                    />

                  </div>
                  {errors.mobile && (
                    <small className="text-danger d-block mt-1">
                      {errors.mobile}
                    </small>
                  )}
                </Col>
                <Col md={6}>
                  <Form.Label className="newformstyle">Responsibility</Form.Label>
                  <div className="input-box arthik_input-box">
                    <input
                      type="text"
                      id="responsibility"
                      className="newinpstyle"
                      placeholder="Enter Responsibility"
                      autoComplete="off"
                      onChange={(e) => setResponsibility(e.target.value)}
                      value={responsibility}
                      required
                      aria-describedby="responsibilitynote"
                      onFocus={() => setResponsibilityFocus(true)}
                      onBlur={() => setResponsibilityFocus(false)}
                    />
                  </div>
                </Col>
              </Row>

            </form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={handleUpdate}
              disabled={!isValidName || !isValidMobile}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showOtpModal}
          onHide={() => setShowOtpModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {otpData?.message || "Generating OTP..."}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {otpData && (
              <>
                <p>
                  {/* <strong>Message:</strong>  */}
                  {/* {otpData.message} */}
                </p>

                {/* <p>
                  <strong>Person ID:</strong> {otpData.person_id}
                </p> */}

                <h3 className="text-center text-primary">
                  {otpData.otp}
                </h3>

                <p className="text-center">
                  <strong>Valid Until:</strong> {otpData.expiry}
                </p>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowOtpModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default AdminSearchUser;